export const GET_MASTER_REPORT_REQUEST = 'GET_MASTER_REPORT_REQUEST';
export const GET_MASTER_REPORT_TASK_REQUEST = 'GET_MASTER_REPORT_TASK_REQUEST';
export const GET_REPORT_CLIENTS_REQUEST = 'GET_REPORT_CLIENTS_REQUEST';
export const GET_REPORT_ACCOUNTS_REQUEST = 'GET_REPORT_ACCOUNTS_REQUEST';
export const GET_REPORT_USERS_REQUEST = 'GET_REPORT_USERS_REQUEST';
export const GET_RETAINERS_REQUEST = 'GET_RETAINERS_REQUEST';
export const GET_PROJECT_PROFITABILITY_REQUEST = 'GET_PROJECT_PROFITABILITY_REQUEST';
export const GET_RESOURCE_UTILIZATION_REQUEST = 'GET_RESOURCE_UTILIZATION_REQUEST';
export const GET_DAILY_HOURS_REQUEST = 'GET_DAILY_HOURS_REQUEST';
export const GET_MY_DAILY_HOURS_REQUEST = 'GET_MY_DAILY_HOURS_REQUEST';
export const GET_REPORT_DEPARTMENTS_REQUEST = 'GET_REPORT_DEPARTMENTS_REQUEST';
export const GET_AR_AGING_REQUEST = 'GET_AR_AGING_REQUEST';
export const GET_PROFITABILITY_TREND_REQUEST = 'GET_PROFITABILITY_TREND_REQUEST';
export const GET_HOURS_POSTED_REQUEST = 'GET_HOURS_POSTED_REQUEST';

export const getMasterReport = (filters, callback) => ({
  type: GET_MASTER_REPORT_REQUEST,
  payload: { filters, callback }
});

export const getMasterReportTask = (taskId, callback) => ({
  type: GET_MASTER_REPORT_TASK_REQUEST,
  payload: { taskId, callback }
});

export const getReportClients = (callback) => ({
  type: GET_REPORT_CLIENTS_REQUEST,
  payload: { callback }
}); 

export const getReportAccounts = (client, callback) => ({
  type: GET_REPORT_ACCOUNTS_REQUEST,
  payload: { client, callback }
});

export const getReportUsers = (callback) => ({
  type: GET_REPORT_USERS_REQUEST,
  payload: { callback }
});

export const getRetainers = (startDate, endDate, callback) => ({
  type: GET_RETAINERS_REQUEST,
  payload: { startDate, endDate, callback }
});

export const getProjectProfitability = (startDate, endDate, callback) => ({
  type: GET_PROJECT_PROFITABILITY_REQUEST,
  payload: { startDate, endDate, callback }
});

export const getResourceUtilization = (startDate, endDate, groupByMonth, callback) => ({
  type: GET_RESOURCE_UTILIZATION_REQUEST,
  payload: { startDate, endDate, groupByMonth, callback }
});

export const getDailyHours = (startDate, endDate, callback) => ({
  type: GET_DAILY_HOURS_REQUEST,
  payload: { startDate, endDate, callback }
});

export const getMyDailyHours = (startDate, endDate, callback) => ({
  type: GET_MY_DAILY_HOURS_REQUEST,
  payload: { startDate, endDate, callback }
});

export const getReportDepartments = (callback) => ({
  type: GET_REPORT_DEPARTMENTS_REQUEST,
  payload: { callback }
});

export const getArAging = (callback) => ({
  type: GET_AR_AGING_REQUEST,
  payload: { callback }
});

export const getProfitabilityTrend = (startDate, endDate, callback) => ({
  type: GET_PROFITABILITY_TREND_REQUEST,
  payload: { startDate, endDate, callback }
});

export const getHoursPosted = (startDate, endDate, callback) => ({
  type: GET_HOURS_POSTED_REQUEST,
  payload: { startDate, endDate, callback }
});